import { RouteRecordRaw } from 'vue-router';

import {
  useCampaignStore,
  useEditCampaignStore,
  useRootStore,
} from '@/store';

// キャンペーン関連
export const campaignRoutes: Array<RouteRecordRaw> = [
  {
    name: 'Campaign',
    component: () => import('@/components/pages/campaign/index.vue'),
    path: '/campaign',
    meta: {
      title: 'キャンペーン',
      requiredAuthority: 'CAMPAIGNS',
    },
  },
  {
    name: 'CampaignAdd',
    path: '/campaign/add',
    component: () => import('@/components/pages/campaign/add/index.vue'),
    meta: {
      title: 'キャンペーン登録',
      requiredAuthority: 'EDIT_CAMPAIGNS',
    },
    beforeEnter: (to, from, next) => {
      // 確認画面以外から遷移した場合はキャンペーンの状態管理を初期化
      if (from.name === 'CampaignAddConfirm' || from.name === 'CampaignDetail') {
        next();
      } else {
        useCampaignStore().$reset();
        useRootStore().$reset();
        next();
      }
    },
  },
  {
    name: 'CampaignAddConfirm',
    path: '/campaign/add/confirm',
    component: () => import('@/components/pages/campaign/add/confirm/index.vue'),
    meta: {
      title: 'キャンペーン登録確認',
      requiredAuthority: 'EDIT_CAMPAIGNS',
    },
    beforeEnter: (to, from, next) => {
      const store = useCampaignStore();
      const { form } = store;

      // キャンペーン登録画面以外から遷移した場合は登録画面に飛ばす
      if (from.path === '/campaign/add' && form != null) {
        next();
      } else {
        next({ path: '/campaign/add', replace: true });
      }
    },
  },
  {
    name: 'CampaignDetail',
    component: () => import('@/components/pages/campaign/detail/index.vue'),
    path: '/campaign/:id([^\\(generate\\)]+)', // campaign/generateとの競合を避ける
    meta: {
      title: 'キャンペーン詳細',
      requiredAuthority: 'CAMPAIGNS',
    },
  },
  {
    name: 'CampaignEdit',
    component: () => import('@/components/pages/campaign/detail/edit/index.vue'),
    path: '/campaign/:id/edit',
    meta: {
      title: 'キャンペーン編集',
      requiredAuthority: 'EDIT_CAMPAIGNS',
    },
    beforeEnter: async (to, from, next) => {
      const id = to.params.id.toString();

      // 確認画面以外から遷移した場合はstoreを初期化
      if (!(from.name === 'CampaignAddConfirm' || from.name === 'CampaignDetail')) {
        useCampaignStore().$reset();
        useRootStore().$reset();
      }
      const editCampaignStore = useEditCampaignStore();
      const campaign = await editCampaignStore.getEditCampaign(id);

      const canEdit = !(campaign.shopCsvStatus === 'PROCESSING' || campaign.shopCsvStatus === 'UPLOAD_FAILURE' || campaign.shopCsvStatus === 'FAILURE')
      && (campaign.status === 'WAITING' || campaign.status === 'IN_PROGRESS')
      && campaign.approvalStatus === 'APPROVE';

      if (canEdit) {
        next();
      } else {
        next({ path: `/campaign/${id}`, replace: true, force: true });
      }
    },
  },
  {
    name: 'CampaignEditConfirm',
    component: () => import('@/components/pages/campaign/detail/edit/confirm/index.vue'),
    path: '/campaign/:id/edit/confirm',
    meta: {
      title: 'キャンペーン編集確認',
      requiredAuthority: 'EDIT_CAMPAIGNS',
    },
    beforeEnter: async (to, from, next) => {
      const id = to.params.id.toString();
      const store = useEditCampaignStore();
      const {
        form,
        initData,
      } = store;

      if (from.path === `/campaign/${id}/edit` && !(form == null || initData == null)) {
        next();
      } else {
        next({ path: `/campaign/${id}`, replace: true });
      }
    },
  },
];
